/**
 * app-context.js
 * helper to determine if we should render for PT1 app context
 */

import lightTheme from '../themes/default/light';


// PT1-RETIRE
// determines if we are in the device context
export function renderForMobileContext() {
  const hostname = window.location.hostname;
  return window.ReactNativeWebView !== undefined 
    || hostname.includes('mobilept1.mypacktrack.com')
    || hostname === 'mobile.pt.ngrok.io';
}


// decides which drawer we use
export function shouldRenderMobileLayout() {
  return window.innerWidth < lightTheme.breakpoints.values.sm_md;
}


// bit of an odd scenario but used when between sm and desktop drawer
// and we want to render the mobile layout in the drawer content.
export function shouldRenderMobileInDesktopDrawer() {
  return window.innerWidth >= lightTheme.breakpoints.values.sm_md
    && window.innerWidth < lightTheme.breakpoints.values.md;
}


export function isTouchDevice() {
  //console.log("isTouchDevice: " + window.matchMedia("(pointer: coarse)").matches);
  return window.matchMedia("(pointer: coarse)").matches;
}


export function isUsingMouse() {
  //console.log("isUsingMouse: " + (!!('onmousemove' in window) && !('ontouchstart' in window)));
  return !!('onmousemove' in window) && !('ontouchstart' in window);
}


export function isUsingTouchInput() {
  //console.log("isUsingTouchInput: " + (isTouchDevice() && !isUsingMouse()));
  return isTouchDevice() && !isUsingMouse();
}


// Ridonkulously bad way to test if user is running IE
export function isIE() {
  return navigator.userAgent.indexOf("MSIE ") > -1 || 
    navigator.userAgent.indexOf("Trident/") > -1;
}